/**
 * HTML escaping — the single definition site for the whole site.
 *
 * Every page that builds markup by string concatenation loads this first and
 * calls `GHD.escapeHtml`. Do not hand-roll a local escape helper: the
 * `textContent` → `innerHTML` trick that reads as equivalent does NOT escape
 * double quotes, so its output breaks out of a quoted attribute.
 *
 * Extends the `window.GHD` namespace. Load before every other GHD file and
 * before any page script that renders user-supplied values.
 */
(function () {
  window.GHD = window.GHD || {};

  // Escape a value for safe insertion into innerHTML *or* a quoted attribute
  // (quotes are escaped too, so it is safe in both positions). Null and
  // undefined become the empty string; non-strings are coerced.
  GHD.escapeHtml = function (value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  };
})();
